
 $('#addToCart').click(function () {
   var productVendor = $('#productVendor').val();
   if(productVendor == "nmi-training")
   {     
		var optionTitle = $("select[id^='productSelect'] option:selected").first().text();
      	var trainingAttributes = optionTitle.split('-');
		if(trainingAttributes.length == 3)
        {
   			$("#program-start-date").val(trainingAttributes[0]);
   			$("#program-end-date").val(trainingAttributes[1]);
   			$("#program-location").val(trainingAttributes[2]);  
        }
     	else if(trainingAttributes.length == 2)
        {
          	$("#program-start-date").val(trainingAttributes[0]);
   			$("#program-end-date").val('');
   			$("#program-location").val(trainingAttributes[1]);  
        }
   }
   
   var productTitle = $('h1[itemprop=name]').text();

   if(productTitle == "Perform standard calibrations")
   {
     var optionTitle = $("select[id^='productSelect'] option:selected").first().text();
     $("#subclass").val(optionTitle);  
   }    
 });